<script setup lang="ts">

interface TabButtonItem {
  label: string;
  command?: () => void;
}

interface TabButtonPanelProps {
  items: TabButtonItem[];
  activeItem: number;
}

defineProps<TabButtonPanelProps>();

const emit = defineEmits<{ (e: 'on:item-select', item: number) }>();

const onItemClick = (item: TabButtonItem, index: number) => {
  emit('on:item-select', index);
  if (typeof item.command === 'function') {
    item.command();
  }
};
</script>
<template>
  <div class="flex justify-stretch w-full rounded-lg border border-[var(--light-neutral-border)] overflow-hidden">
    <div
      v-for="(item, key) in items"
      :key="key"
      class="flex-1 flex items-center justify-center h-9 cursor-pointer"
      :class="{'bg-[var(--light-neutral-background)]': key === activeItem, 'border-l border-[var(--light-neutral-border)]': key > 0}"
      @click="onItemClick(item, key)"
    >
      <span>{{ item.label }}</span>
    </div>
  </div>
</template>
